(function ($)
{
	//Zooms, with crosshairs rather than just a vertical cursor
	window.CrosshairZoomTool = function () { };
	CrosshairZoomTool.prototype.TOOL_ID = "CrosshairZoomTool";
	CrosshairZoomTool.prototype = new ZoomTool();

	//Event handlers
	CrosshairZoomTool.prototype._handleMouseOver = function (oEvent, oEl) {
		var jPanel = $(oEl);
		this._offsetY = jPanel.offset().top;
		this._offsetX = jPanel.offset().left;
		jPanel.addClass("tool-active");
	};
	//Display
	CrosshairZoomTool.prototype._setCursors = function () {
		var oTool = this;
		this._cursors = $();
		this._horizontalCursors = $();
		this._verticalCursors = $();
		var oOuptputData = this._chart.GetOutputData() || {};
		var rPanelData = oOuptputData.Panels || [];
		this._getPanelElements().each(function (i) {
			if (!rPanelData[i] || !rPanelData[i].IsValid) { return true; }
			var jPanel = $(this);
			var jCursor = oTool._buildCursor(jPanel).addClass("vertical").css("left", oTool._getLastDataPoint(i) + "px"); ;
			var jHorizontalCursor = oTool._horizontalCursor = oTool._buildHorizontalCursor(jPanel);
			jPanel.append(jCursor);
			jPanel.append(jHorizontalCursor);
			oTool._horizontalCursors = oTool._horizontalCursors.add(jHorizontalCursor);
			oTool._verticalCursors = oTool._verticalCursors.add(jCursor);
			oTool._cursors = oTool._cursors
				.add(jCursor)
				.add(jHorizontalCursor);
		});
	};
	CrosshairZoomTool.prototype._buildHorizontalCursor = function (jPanel) {
		var jCursor = $("<div class='cursor zoom-tool-cursor horizontal'></div>");
		jCursor.width(jPanel.width());
		//Keep mousedown event from firing twice
		jCursor.mousedown(function (e) { e.stopPropagation(); return false; });
		return jCursor;
	};
	CrosshairZoomTool.prototype._positionCursors = function (oMouse) {
		var oData = this._getDataForLatestXCoord(oMouse.x - this._offsetX);
		if (!oData) { return; }
		this._verticalCursors.css({ left: oData.CloseX + "px" });
		this._horizontalCursors.css({ top: oMouse.y - this._offsetY + "px" });
	};
	CrosshairZoomTool.prototype.Reset = function () {
		$(this._cursors).remove();
		$(this._overlays).remove();
		$(this._horizontalCursors).remove();
		this._setCursors();
		this._setOverlays();
		this._applyEvents();
		this._startTracking();
	};
})(jQuery);